module.exports = __webpack_public_path__ + "img/cakesmash.0712ef3e.jpg";